import GlobalMenuButton from './global-menu-button';
import GlobalMenuItem from './global-menu-item';

let defaultSites = null;

export default class GlobalSitesMenuButton extends GlobalMenuButton {

  render(template, defaultOptions) {
    super.render(template, defaultOptions);
    defaultSites = defaultOptions;

    let titleElement = this.element.querySelector('.dt-gnm-menu-button__title');
    titleElement.textContent = 'Site';

    let subtitleElement = this.element.querySelector('.dt-gnm-menu-button__current_option');
    let currentSite = defaultSites[this.currentSite];
    if (currentSite) {
      subtitleElement.textContent = currentSite.title;
    } else {
      this.element.classList.add('no-service');
      subtitleElement.textContent = 'Sites';
    }
  }

  get menuItems() {
    // TODO: Support sites option as array for manual initialization
    const configuredSites = this.sites.split(/[^A-Z]+/);
    const sitesToShow = Object.keys(defaultSites).filter((x) => configuredSites.indexOf(x) !== -1);
    return sitesToShow.map((siteIdentifier) => {
      const siteInstance = new GlobalMenuItem(defaultSites[siteIdentifier]);
      if (siteIdentifier == this.currentSite) {
        siteInstance.selected = true;
      }
      return siteInstance.render();
    });
  }
}



// WEBPACK FOOTER //
// ./src/scripts/global-sites-menu-button.js